
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-md-4">
          Purchase Order Search
        </div>
        <div class="col-md-4">
          <div class="row">
            <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
              <a title="Previous" class="nav-link-hand">
                <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
              </a>
            </div>
            <div class="col-md-4 col-sm-4 padding-left-5px padding-right-9px">
              <div class="date-form billing-calender">
                <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px  data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                       name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                       (ngModelChange)="dataChanged($event)">
                <a (click)="d.toggle()" class="nav-link-hand">
                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>
                </a>
              </div>
            </div>
            <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
              <a title="Next" class="nav-link-hand">
                <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
              </a>
            </div>

          </div>
        </div>
        <div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
          <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
            <div class="clear-form">
              <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
              <a class="nav-link-hand" title="Clear"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
            </div>
            <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
          </form>
        </div>

        <div class="col-md-1 padding-left-0px">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.close('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <div class="modal-body padding-top-0px counselling-modal">

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero "
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>
                        <th></th>
                        <th class="">
                          Order Code
                        </th>
                        <th class="">
                          Store Name
                        </th>
                        <th class="">
                          Order Date
                        </th>
                        <th class="">
                          Delivery By
                        </th>
                        <th class="">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentPurchaseOrdersListController">
                        <td class="padding-all-0px">
                          <button type="button" class="btn font-size-13px actions-btn-prime"
                                   (click)="SelectedOrder(l)">                                  
                            Select
                          </button>                          
                        </td>
                        <td class="td-padding">
                          {{l.PurchaseOrderCode}}
                        </td>
                        <td class="td-padding">
                          {{l.ShipToLocation}}
                        </td>
                        <td class="td-padding">
                          {{l.OrderDate| date:'MMM-dd-yyyy'}}
                        </td>
                        <td class="td-padding">
                          {{l.DeliveryDate| date:'MMM-dd-yyyy'}}
                        </td>                        
                        <td class="td-padding">
                          {{l.OrderStatus}}
                        </td>                        
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
